
<img src="assets/images/loading.svg" alt="Loading">

<h1>Loading...</h1>

<mat-progress-bar mode="indeterminate"/>
